/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AuthService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * User login
     * Authenticates a user and returns an access token.
     * @returns any User authenticated successfully
     * @throws ApiError
     */
    public postAuthLogin({
        requestBody,
    }: {
        requestBody: {
            username?: string;
            password?: string;
        },
    }): CancelablePromise<{
        accessToken?: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/auth/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized - Invalid credentials`,
                500: `Internal server error`,
            },
        });
    }

}
